import React, {useEffect, useState} from "react";
import {getLiveStream} from "../../redux/actions/livesActions";
import { connect } from "react-redux";
import io from "socket.io-client";
import AgoraRTC from "agora-rtc-sdk-ng";
import '../../scss/pages/ShopperLive.scss'
import LiveBar from "../../components/common/ShooperLive/LiveBar";
import LiveError from "../../components/common/ShooperLive/LiveError";
import { SwitcherProducts } from "../../components/common/ShooperLive/SwitcherProducts";
import Chat from "../../components/common/ShooperLive/Chat";

const socketOptions = {
    secure: true,
    reconnection: true,
    reconnectionDelay: 1000,
    timeout: 15000,
    pingTimeout: 15000,
    pingInterval: 45000,
    query: { framespersecond: 15, audioBitrate: 22050 },
    transports: ["websocket", "polling"],
};

let socket = null

const ShopperLive = ({ match, getLiveStream }) => {
    // eslint-disable-next-line
    const [error, setError] = useState(false)
    // eslint-disable-next-line
    const [loaded, setLoaded] = useState(false)
    const [data, setData] = useState({

    })

    const [messages, setMessage] = useState([]);
    const [name, setName] = useState("");
    const [views, setViews] = useState(0);
    const [scale, setScale] = useState(1);
    const [minimized, setMinimized] = useState(false);
    const [pos, setPos] = useState('b<LiottomRight');
    const [isDrag, setIsDrag] = useState(false);
    const [barOpen, setBarOpen] = useState(false);
    const [isLive, setIsLive] = useState(false);
    const [isClose, setIsClose] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [wasLive, setWasLive] = useState(false);
    const [allAdded, setAllAdded] = useState(false);
    const [addedProd, setAddedProd] = useState({});
    // eslint-disable-next-line
    const [mic, setMic] = useState(null);
    const [switcherProductsId, setSwitcherProductId] = useState([])
    const [posi, setPosi] = useState({
        top: window.innerHeight - 460,
        left: window.innerWidth - 278,
    });

    const client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
    client.setClientRole("audience");


    useEffect(() => {
        socket = io.connect('lives.raddcontent.com', socketOptions)
        getLiveStream({ authToken: 'anon', liveId: match.params.id }).then((res) => {
            setLoaded(true)
            if (res.error) {
                setError(true)
                return
            }
            setData(res.result)
            // eslint-disable-next-line
            const uid = client.join(
                res.result.appID,
                res.result.channelName,
                res.result.token
            );
            client.on("user-unpublished", async (user, mediaType) => {
                if (mediaType === "video") {
                    setIsLive(false);
                }
            });
            client.on("user-published", async (user, mediaType) => {
                setWasLive(true);
                setIsLive(true);

                // trackStory(res.result.data.id, '22')
                await client
                    .subscribe(user, mediaType)
                    .then(console.log("subscribed successfully"));

                console.log(user)

                const remoteVideoTrack = user.videoTrack;
                const audioTrack = user.audioTrack;

                // setMic(audioTrack);

                const livecontainer = document.getElementById("livecontainer");
                
                remoteVideoTrack.play(livecontainer);
                audioTrack.play();
            });

            socket.emit('join_room', match.params.id)

            socket.on('connect_timeout', (timeout) => {
                console.log('state on connection timeout= ' + timeout)
            })

            socket.on('chat_message', (m) => {
                console.log('chat -' + m)
            })
            socket.on('error', (error) => {
                console.log('state on connection error= ' + error)
            })

            setError(false);
            socket.on("update_count", (m) => {
                setViews(m - 1);
            });

            socket.emit("update__viewers");

            socket.on("send_message", (m) => {
                setMessage((prev) => [...prev, { ...m }]);
            });

            if (res.result.products.length !== 0) {
                setSwitcherProductId([])
                const ids = []
                res.result.products.map((el) => {
                    if (el.isShow) {
                        ids.push(el.productId)
                    }
                    return ids
                })
                setSwitcherProductId(ids)
            }

            socket.on('switch_products', (m) => {
                if (m.status) {
                    setSwitcherProductId((prev) => [...prev, m.id])
                } else {
                    setSwitcherProductId((prev) => prev.filter((item) => item !== m.id))
                }
            })

            if (window.innerHeight < 736 && window.innerWidth > 480) {
                setScale(window.innerHeight / 736 - 20 / 736);
            }
            return () => {

                socket.close();
            };
        })

        return () => {
            socket.close()
        }

        // eslint-disable-next-line
    }, [])

    const sendMessage = (data) => {
        socket.emit("chat_message", {
            name,
            text: data,
        });
    };

    const minimizeComponent = (e) => {
        e.stopPropagation();
        setMinimized(!minimized);
    };

    const minimizeAndOpen = (url) => {
        setMinimized(true);
        setTimeout(() => {
            window.location.href = url;
        }, 600);
    };

    const handleDragStart = (e, isTouch = false) => {
        if (!minimized) return;
        e.stopPropagation();
        const startX = !isTouch ? e.pageX : e.touches[0].pageX;
        const startLeft = e.target.getBoundingClientRect().x;
        const startY = !isTouch ? e.pageY - window.scrollY : e.touches[0].pageY;
        const startTop = e.target.getBoundingClientRect().y;
        let currpos = {
            top: posi.top,
            left: posi.left,
        };

        const handleMove = (e) => {
            e.stopPropagation();
            const pageX = !isTouch ? e.pageX : e.touches[0].pageX;
            const pageY = !isTouch ? e.pageY : e.touches[0].pageY;
            currpos = {
                top: startTop - startY + pageY - window.scrollY,
                left: startLeft - startX + pageX,
            };
            setIsDrag(true);
            setPosi({
                top: startTop - startY + pageY - window.scrollY,
                left: startLeft - startX + pageX,
            });
        };

        const handleUp = () => {
            setPos(
                (currpos.top + 220 < window.innerHeight / 2 ? "top" : "bottom") +
                (currpos.left + 124 < window.innerWidth / 2 ? "Left" : "Right")
            );
            setIsDrag(false);
            if (isTouch) {
                document.removeEventListener("touchmove", handleMove);
                document.removeEventListener("touchend", handleUp);
            } else {
                document.removeEventListener("mousemove", handleMove);
                document.removeEventListener("mouseup", handleUp);
            }
        };
        if (isTouch) {
            document.addEventListener("touchmove", handleMove);
            document.addEventListener("touchend", handleUp);
        } else {
            document.addEventListener("mousemove", handleMove);
            document.addEventListener("mouseup", handleUp);
        }
    };

 return (
     <React.Fragment>
         <div
             className="live__test__overlay"
             style={minimized ? { display: "none" } : { display: "block" }}
             onClick={minimizeComponent}
         ></div>
         <div className="live__test__wrapper">
             <div
                 style={
                     !minimized
                         ? {
                             transform: `scale(${scale})`,
                             transformOrigin: "center",
                         }
                         : isDrag
                             ? { top: posi.top, left: posi.left }
                             : {}
                 }
                 className={`live__test${minimized ? ` minimized ${pos}` : ""}${
                     isDrag ? " dragging" : ""
                 }`}
                 onMouseDown={(e) => handleDragStart(e, false)}
                 onTouchStart={(e) => handleDragStart(e, true)}
             >
                 {!minimized &&
                     data.products &&
                     data.products.filter((el) => !el.error).length !== 0 && (
                         <LiveBar
                             isOpen={barOpen}
                             setOpen={(val) => {
                                 setBarOpen(val);
                             }}
                             avatar={data.influencer}
                             title={data.name}
                             name={data.name}
                             allAdded={allAdded}
                             setAllAdded={setAllAdded}
                             addedProd={addedProd}
                             setAddedProd={setAddedProd}
                             products={data.products.filter((el) => !el.error)}
                             storyId={data.id}
                             barId={"22"}
                             setMinimized={minimizeAndOpen}
                         />
                     )}
                 <div className="live__container" id="livecontainer"></div>
                 {!isLive && (
                     <LiveError
                         time={data?.time ? data?.time?.split("+")[0] : new Date()}
                         isLive={isLive}
                         org={data.orgName}
                         wasLive={wasLive}
                     />
                 )}
                 <div className="author">
                     <div className="avatar">
                         <div
                             className="profile__avatar"
                             style={{
                                 backgroundImage: `url("${data.influencer}")`,
                                 backgroundSize: "contain",
                                 backgroundPosition: "center center",
                                 backgroundRepeat: "no-repeat",
                             }}
                         />
                     </div>
                     <div className="info">
                         <div className={isLive || !wasLive ? 'more' : 'more black'}><p>{data.name}</p></div>
                         <div className="name">
                             <svg
                                 width="17"
                                 height="10"
                                 viewBox="0 0 17 10"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                                 style={{ marginRight: 8 }}
                             >
                                 <path
                                     fill-rule="evenodd"
                                     clip-rule="evenodd"
                                     d="M1.00134 5.00217L1.0009 5.00045L1.00134 4.99873C1.00553 4.98228 1.02265 4.915 1.09211 4.78669C1.17289 4.63748 1.30041 4.44945 1.47656 4.23409C1.82799 3.80444 2.34695 3.29774 2.99618 2.81348C4.29956 1.8413 6.0722 1 8.00183 1C9.93147 1 11.7041 1.8413 13.0075 2.81348C13.6567 3.29774 14.1757 3.80444 14.5271 4.23409C14.7033 4.44945 14.8308 4.63748 14.9116 4.78669C14.981 4.915 14.9981 4.98228 15.0023 4.99873L15.0028 5.00045L15.0023 5.00217C14.9981 5.01862 14.981 5.0859 14.9116 5.21421C14.8308 5.36342 14.7033 5.55146 14.5271 5.76681C14.1757 6.19646 13.6567 6.70316 13.0075 7.18742C11.7041 8.1596 9.93147 9.0009 8.00183 9.0009C6.0722 9.0009 4.29956 8.1596 2.99618 7.18742C2.34695 6.70316 1.82799 6.19646 1.47656 5.76681C1.30041 5.55146 1.17289 5.36342 1.09211 5.21421C1.02265 5.0859 1.00553 5.01862 1.00134 5.00217ZM8.00183 0C5.78832 0 3.81004 0.958883 2.39829 2.0119C1.68996 2.54024 1.1103 3.1024 0.702507 3.60097C0.499039 3.84972 0.331795 4.09064 0.21271 4.31061C0.102512 4.51416 0 4.75963 0 5.00045C0 5.24127 0.102512 5.48674 0.21271 5.69029C0.331795 5.91026 0.499039 6.15118 0.702507 6.39993C1.1103 6.8985 1.68996 7.46066 2.39829 7.989C3.81004 9.04202 5.78832 10.0009 8.00183 10.0009C10.2153 10.0009 12.1936 9.04202 13.6054 7.989C14.3137 7.46066 14.8934 6.8985 15.3012 6.39993C15.5046 6.15118 15.6719 5.91026 15.791 5.69029C15.9012 5.48674 16.0037 5.24127 16.0037 5.00045C16.0037 4.75963 15.9012 4.51416 15.791 4.31061C15.6719 4.09064 15.5046 3.84972 15.3012 3.60097C14.8934 3.1024 14.3137 2.54024 13.6054 2.0119C12.1936 0.958883 10.2153 0 8.00183 0ZM5.68896 4.99996C5.68896 3.80389 6.70511 2.79969 8.00215 2.79969C9.29919 2.79969 10.3153 3.80389 10.3153 4.99996C10.3153 6.19602 9.29919 7.20023 8.00215 7.20023C6.70511 7.20023 5.68896 6.19602 5.68896 4.99996ZM8.00215 1.79969C6.19183 1.79969 4.68896 3.21339 4.68896 4.99996C4.68896 6.78652 6.19183 8.20023 8.00215 8.20023C9.81247 8.20023 11.3153 6.78652 11.3153 4.99996C11.3153 3.21339 9.81247 1.79969 8.00215 1.79969Z"
                                     fill="#F8F9FA"
                                 />
                             </svg>
                             {views}
                         </div>
                     </div>
                 </div>
                 {!minimized && isLive && (
                     <SwitcherProducts products={data.products.filter((el) => switcherProductsId.some((item) => el.productId === item))}
                                       storyId={data.id}
                                       allAdded={allAdded}
                                       setAllAdded={setAllAdded}
                                       addedProd={addedProd}
                                       setAddedProd={setAddedProd}
                                       barId={"22"} />
                 )}
                 {!minimized && isLive && (
                     <Chat
                         messages={messages}
                         setUserName={setName}
                         sendMessage={sendMessage}
                         name={name}
                         setBarOpen={setBarOpen}
                         isMuted={isMuted}
                         setIsMuted={setIsMuted}
                         org={data.orgName}
                         minimized={minimized}
                         mic={mic}
                     />
                 )}
             </div>
             {isClose && (
                 <div className="live__test__overlay middle__align zIndMax">
                     <div className="modal__window">
                         <div
                             className="modal__close"
                             onClick={() => {
                                 setIsClose(false);
                             }}
                         >
                             <svg
                                 width="18"
                                 height="18"
                                 viewBox="0 0 18 18"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                             >
                                 <path
                                     d="M10.9422 9.00001L16.8031 3.13907C17.3359 2.60626 17.3359 1.72969 16.8031 1.19688C16.2703 0.664069 15.3938 0.664069 14.8609 1.19688L9 7.05782L3.13906 1.19688C2.60625 0.664069 1.72969 0.664069 1.19687 1.19688C0.930469 1.46329 0.792969 1.81563 0.792969 2.16798C0.792969 2.52032 0.930469 2.87266 1.19687 3.13907L7.05781 9.00001L1.19687 14.8609C0.930469 15.1274 0.792969 15.4797 0.792969 15.832C0.792969 16.1844 0.930469 16.5367 1.19687 16.8031C1.72969 17.3359 2.60625 17.3359 3.13906 16.8031L9 10.9422L14.8609 16.8031C15.3938 17.3359 16.2703 17.3359 16.8031 16.8031C17.3359 16.2703 17.3359 15.3938 16.8031 14.8609L10.9422 9.00001Z"
                                     fill="#777F81"
                                 />
                             </svg>
                         </div>
                         <div className="modal__text">
                             Are you sure you want to exit the LIVE story?
                         </div>
                         <div className="buttons__modal">
                             <div
                                 className="publish__button"
                                 onClick={() => {
                                     setIsClose(false);
                                 }}
                             >
                                 Continue watching
                             </div>
                             <div
                                 id="leaveStream"
                                 className="cancel__button"
                                 onClick={() => {
                                     localStorage.removeItem(`continueRaddLive`);
                                 }}
                             >
                                 Exit
                             </div>
                         </div>
                     </div>
                 </div>
             )}
         </div>
     </React.Fragment>
 )
}

const mapStateToProps = (state) => {
    const auth = state.auth.toJS()
    let { idToken, orgInfo } = auth

    return {
        idToken, orgInfo
    }
}

const mapDispatchToProps = {
    getLiveStream,
}

export default connect(mapStateToProps, mapDispatchToProps, null)(ShopperLive)